import Stripe from 'stripe';

export const getStripeInstance = (key: string) => {
  const stripeInstance = new Stripe(key, { apiVersion: '2025-07-30.basil' });
  return stripeInstance;
};
